import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMap, FiCpu, FiFileText, FiTarget } = FiIcons;

const Deliverables = () => {
  const items = [
    { icon: FiMap, title: "Prozesslandkarte", desc: "Eine visuelle Übersicht Ihrer gesamten Geschäftsabläufe." },
    { icon: FiCpu, title: "Architekturdiagramm", desc: "Der technische Bauplan für Ihre Systemlandschaft." },
    { icon: FiFileText, title: "Entscheidungslogik", desc: "Definition klarer Regeln für Ihre Automatisierung." },
    { icon: FiTarget, title: "Umsetzungsplan", desc: "Priorisierte Schritte für Ihre IT oder Entwickler." }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">Ihr Ergebnis</h2>
            <p className="text-lg text-gray-600">Das erhalten Sie am Ende unserer Zusammenarbeit – schwarz auf weiß.</p>
          </div>
          
          <div className="grid md:grid-cols-4 gap-8">
            {items.map((item, i) => (
              <div key={i} className="text-center">
                <div className="w-16 h-16 bg-azure-50 text-azure-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <SafeIcon icon={item.icon} className="text-2xl" />
                </div>
                <h4 className="font-bold text-black mb-2">{item.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Deliverables;